import { render, staticRenderFns } from "./SectionEmpty.vue?vue&type=template&id=7a74433c&scoped=true&"
import script from "./SectionEmpty.vue?vue&type=script&lang=js&"
export * from "./SectionEmpty.vue?vue&type=script&lang=js&"
import style0 from "./SectionEmpty.vue?vue&type=style&index=0&id=7a74433c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a74433c",
  null
  
)

export default component.exports